import { ComponentProps } from "@declarations/props";
import { useThemeStore } from "@stores/theme.store";
import { BottomNavigation } from "@components/general/bottom_navigation";
import { AppBar } from "@components/general/app_bar";

export const BaseLayout: ComponentProps = ({ children }) => {
  const { appBar, bottomNavigation } = useThemeStore((state) => state);
  return (
    <div className="tw-h-screen">
      <div id="page">
        {appBar.show && <AppBar />}
        <div className="page-content">{children}</div>
        {bottomNavigation !== "hidden" && (
          <BottomNavigation type={bottomNavigation} />
        )}
      </div>
    </div>
  );
};
